import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6901ProposalTabModel } from "../kymw6901-proposal-tab.model";

type ImagePhotoDownloadResponse = {
  ImagePhotoUrl: string;
};

/**
 * イメージ写真ファイルをダウンロードするサービス
 *
 * @export ImagePhotoDownloadService
 * @class ImagePhotoDownloadService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class ImagePhotoDownloadService extends PlessJsonResponderSub<ImagePhotoDownloadResponse> {
  private model: KYMW6901ProposalTabModel;
  private successFunc = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ImagePhotoDownloadService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ProposalId: this.model.newGoodsProposal.proposalId,
        ImagePhoto: this.model.newGoodsProposal.imageFileName
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof ImagePhotoDownloadService
   */
  execute(model: KYMW6901ProposalTabModel, successFunc?: (filePath: string) => void): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('imagePhotoDownload', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * 
   * @memberof ImagePhotoDownloadService
   */
  success(data: ImagePhotoDownloadResponse): void {
    if (this.successFunc) {
      this.successFunc(data.ImagePhotoUrl);
    }
  }
}

